import { HyperDropAccordion } from './components/HyperDropAccordion';
import { HyperDropAccordionList } from './components/HyperDropAccordionList';

(function (Drupal) {
  Drupal.behaviors.hyperdropAccordion = {
    attach(context: HTMLElement) {
      // Single collapses
      context.querySelectorAll<HTMLElement>('[data-component="accordion"]').forEach(el => {
        new HyperDropAccordion({
          elements: { accordion: el.querySelector('.accordion-item') as HTMLElement }
        });
      });

      // Collapse lists
      context.querySelectorAll<HTMLElement>('[data-component="accordion-list"]').forEach(el => {
        new HyperDropAccordionList({
          elements: { accordions: Array.from(el.querySelectorAll('.accordion-item')) }
        });
      });
    }
  };
})(Drupal as any);
